import { render } from "./AddBitrixLeadButton.vue?vue&type=template&id=5ff64fa4"
import script from "./AddBitrixLeadButton.vue?vue&type=script&lang=js"
export * from "./AddBitrixLeadButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__